import { render, staticRenderFns } from "./FlashBox.vue?vue&type=template&id=1e794924&"
import script from "./FlashBox.vue?vue&type=script&lang=js&"
export * from "./FlashBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports